import React from "react";

import { useTicketTransferNewContext } from "./TicketTransferNewContainer";

const stepContainer = {
  border: "1px solid #E9EAEB",
  boxShadow: "0px 1px 2px 0px #0A0D120D",
  display: "flex",
  flexDirection: "column",
  borderRadius: "8px",
  marginBottom: "20px",
  padding: "20px",
  alignItems: "center",
};

const formStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "20px",
  justifyContent: "center",
  marginBottom: "10px",
  maxWidth: "500px",
  width: "100%",
};

const inputContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  color: "#333333",
  maxWidth: "100%",
}

const inputStyle = {
  borderRadius: "5px",
  border: "1px solid #E5E5E5",
  padding: "10px",
  width: "240px",
  maxWidth: "100%",
};

const emailInputStyle = {
  ...inputStyle,
  width: "500px",
};

const noteInputStyle = {
  ...inputStyle,
  width: "500px",
  height: "120px",
};

const submitButtonStyle = {
  width: "500px",
  color: "white",
  fontSize: 14,
  fontWeight: 600,
  borderRadius: "8px",
  border: "none",
  padding: 5,
};

const RecipientForm = () => {
  const {
    recipient,
    setRecipient,
    handleSubmit,
    isSubmitting,
    isSubmitted,
  } = useTicketTransferNewContext();

  const isSubmitDisabled = () => {
    return !recipient.firstName || !recipient.lastName || !recipient.email || isSubmitting || isSubmitted;
  };

  return (
    <div style={stepContainer}>
      <form style={formStyle}>
        <div style={inputContainerStyle}>
          <div>First name <span style={{ color: "#FF595E" }}>*</span></div>
          <input id="firstName" name="firstName" placeholder="First name" type="text"
            disabled={isSubmitting || isSubmitted}
            style={inputStyle}
            value={recipient.firstName}
            onChange={(e) => setRecipient({ ...recipient, firstName: e.target.value })}
          />
        </div>
        <div style={inputContainerStyle}>
          <div>Last name <span style={{ color: "#FF595E" }}>*</span></div>
          <input id="lastName" name="lastName" placeholder="Last name" type="text"
            disabled={isSubmitting || isSubmitted}
            style={inputStyle}
            value={recipient.lastName}
            onChange={(e) => setRecipient({ ...recipient, lastName: e.target.value })}
          />
        </div>
        <div style={inputContainerStyle}>
          <div>Email <span style={{ color: "#FF595E" }}>*</span></div>
          <input id="email" name="email" placeholder="Email address" type="email"
            disabled={isSubmitting || isSubmitted}
            style={emailInputStyle}
            value={recipient.email}
            onChange={(e) => setRecipient({ ...recipient, email: e.target.value })}
          />
        </div>
        <div style={inputContainerStyle}>
          <div>Add a note</div>
          <textarea id="note" name="note" placeholder="Enter a note..."
            disabled={isSubmitting || isSubmitted}
            style={noteInputStyle}
            value={recipient.note}
            onChange={(e) => setRecipient({ ...recipient, note: e.target.value })}
          />
        </div>
        <button type="submit"
          disabled={isSubmitDisabled()}
          onClick={handleSubmit}
          style={{
            ...submitButtonStyle,
            backgroundColor: isSubmitDisabled() ? "#FF595E80" : "#FF595E",
          }}>
          Transfer Tickets
        </button>
      </form>
    </div>
  );
};

export default RecipientForm;
